export function MapToServerSideEnum(name: string) {
  const actualDecorator = (target: any): void => {
    target.enumName = name;
  };

  return actualDecorator;
}
